export default "__VITE_ASSET__B673jutW__"